<template>
  <div class="chatbot-wrapper">
    <!-- Botão Flutuante -->
    <!-- <div
      v-if="!isOpen"
      class="chatbot-button"
      @click="openChat"
      title="💡 Precisa de ajuda?"
    >
      <feather-icon icon="HelpCircleIcon" size="28" />
      <span class="pulse-ring"></span>
    </div> -->

    <!-- Modal do Chat -->
    <div v-if="isOpen" class="chatbot-container">
      <!-- Header -->
      <div class="chatbot-header">
        <div class="header-content">
          <feather-icon icon="BotIcon" size="20" />
          <span>ChatBot IT4D</span>
        </div>
        <feather-icon
          icon="XIcon"
          size="20"
          class="close-btn"
          @click="closeChat"
        />
      </div>

      <!-- Chat Messages -->
      <div class="chatbot-messages" ref="messagesContainer">
        <div
          v-for="(message, index) in messages"
          :key="index"
          :class="['message', message.type]"
        >
          <div class="message-content" v-if="message.type !== 'input'">
            <p v-html="message.text"></p>

            <!-- Botões de resposta Yes/No -->
            <div v-if="message.showButtons" class="response-buttons">
              <button
                class="btn-yes"
                @click="handleResponse(true)"
                :disabled="waitingForResponse"
              >
                ✅ Sim
              </button>
              <button
                class="btn-no"
                @click="handleResponse(false)"
                :disabled="waitingForResponse"
              >
                ❌ Não
              </button>
            </div>
          </div>

          <!-- Input field for text questions -->
          <div v-if="message.type === 'input'" class="input-container-inline">
            <textarea
              v-model="diagnosticData[message.field]"
              :placeholder="`Digite sua resposta...`"
              rows="2"
              @keyup.ctrl.enter="handleTextSubmit(message.field)"
            ></textarea>
            <button
              class="btn-send-inline"
              @click="handleTextSubmit(message.field)"
              :disabled="
                !diagnosticData[message.field] ||
                !diagnosticData[message.field].trim()
              "
            >
              <feather-icon icon="SendIcon" size="16" />
            </button>
          </div>
        </div>

        <!-- Input para descrição inicial -->
        <div v-if="showInitialInput" class="input-container">
          <textarea
            v-model="diagnosticData[currentInputField]"
            :placeholder="currentInputPlaceholder"
            rows="3"
            @keyup.ctrl.enter="submitDescription"
          ></textarea>
          <button
            class="btn-send"
            @click="submitDescription"
            :disabled="
              !diagnosticData[currentInputField] ||
              !diagnosticData[currentInputField].trim()
            "
          >
            <feather-icon icon="SendIcon" size="18" />
            Enviar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ChatbotTriagem",
  data() {
    return {
      isOpen: false,
      currentQuestionId: "inicio",
      showInitialInput: false,
      waitingForResponse: false,
      messages: [],
      systems: [], // Sistemas da API
      departments: [], // Departamentos da API
      diagnosticData: {
        systemName: "",
        systemId: null, // ID do sistema
        departmentName: "",
        departmentId: null, // ID do departamento
        problemType: null, // 'erro' | 'lentidao' | 'duvida'
        description: "",
        errorMessage: "",
        moduleAffected: "",
        limpouCache: null,
        problemaPersiste: null,
        registroEspecifico: null,
        outrosUsuarios: null,
        temInformacoes: null,
        // Campos para lentidão
        testouInternet: null,
        internetOk: null,
        navegador: null,
        testouOutroNavegador: null,
        funcionouOutroNavegador: null,
        abrirChamadoMesmoAssim: null,
      },
      flowQuestions: [
        {
          id: "inicio",
          text: "👋 <strong>Olá! Sou o assistente de diagnóstico.</strong><br><br>Vamos verificar o que está acontecendo antes de abrir um chamado. Isso vai economizar seu tempo!<br><br>🖥️ <strong>Primeiro, qual sistema você está tendo dificuldades?</strong>",
          type: "options",
          field: "systemName",
          options: [
            { value: "INTRANET", label: "🌐 INTRANET" },
            { value: "TIH", label: "🏥 TIH" },
            { value: "TSDIADEMA", label: "🚑 TSDIADEMA" },
            { value: "PRONTIDAO", label: "⚡ PRONTIDAO" },
            { value: "APP SAMU", label: "🚑 APP SAMU" },
            { value: "NOVO SIGAP", label: "🏢 NOVO SIGAP" },
            { value: "ARES TRIAGEM", label: "🏢 ARES TRIAGEM" },
            { value: "DIM - RJ", label: "📊 DIM - RJ" },
            {
              value: "PESQUISA DE SATISFAÇÃO",
              label: "⭐ PESQUISA DE SATISFAÇÃO",
            },
            { value: "outro", label: "✏️ Outro sistema (digitar)" },
          ],
          next: (answer) => {
            if (answer === "outro") return "sistema-outro";
            return "departamento";
          },
        },
        {
          id: "sistema-outro",
          text: "✏️ <strong>Digite o nome do sistema:</strong>",
          type: "text",
          field: "systemName",
          next: "departamento",
        },
        {
          id: "departamento",
          text: "🏢 <strong>Qual departamento é responsável por este chamado?</strong>",
          type: "options",
          field: "departmentName",
          options: [
            { value: "Desenvolvimento", label: "💻 Desenvolvimento" },
            { value: "Power BI", label: "📊 Power BI" },
            { value: "Infraestrutura", label: "🔧 Infraestrutura" },
            { value: "Suporte", label: "🎧 Suporte" },
            { value: "TI", label: "💾 TI" },
            { value: "Financeiro", label: "💰 Financeiro" },
            { value: "RH", label: "👥 RH" },
            { value: "Comercial", label: "📈 Comercial" },
            { value: "outro", label: "✏️ Outro (digitar)" },
          ],
          next: (answer) => {
            if (answer === "outro") return "departamento-outro";
            return "descricao";
          },
        },
        {
          id: "departamento-outro",
          text: "✏️ <strong>Digite o nome do departamento:</strong>",
          type: "text",
          field: "departmentName",
          next: "descricao",
        },
        {
          id: "descricao",
          text: "📝 <strong>Agora, descreva brevemente o problema:</strong>",
          type: "text",
          field: "description",
          next: "tipoproblema",
        },
        {
          id: "tipoproblema",
          text: "🔍 <strong>O sistema está apresentando:</strong>",
          type: "options",
          field: "problemType",
          options: [
            {
              value: "erro",
              label: "❌ Erro (mensagem de erro, tela branca, etc)",
            },
            { value: "lentidao", label: "🐌 Lentidão (demora para carregar)" },
            { value: "duvida", label: "❓ Dúvida ou comportamento inesperado" },
          ],
          next: (answer) => {
            if (answer === "erro") return "mensagemerro";
            if (answer === "lentidao") return "lentidao-internet"; // Novo fluxo
            return "modulo";
          },
        },
        {
          id: "lentidao-internet",
          text: "🌐 <strong>Você já testou sua conexão de internet?</strong><br><br>Acesse <a href='https://www.speedtest.net/' target='_blank'>Speedtest</a> e verifique sua velocidade.",
          type: "options",
          field: "testouInternet",
          options: [
            {
              value: "sim-ok",
              label: "✅ Sim, está normal (acima de 10 Mbps)",
            },
            {
              value: "sim-lenta",
              label: "⚠️ Sim, está lenta (abaixo de 10 Mbps)",
            },
            { value: "nao", label: "❌ Não testei ainda" },
          ],
          next: (answer) => {
            if (answer === "sim-lenta") return "lentidao-problema-internet";
            if (answer === "nao") return "lentidao-solicita-teste";
            return "lentidao-navegador";
          },
        },
        {
          id: "lentidao-problema-internet",
          text: "📡 <strong>Sua internet está lenta!</strong><br><br>Sugestões:<br>• Reinicie seu roteador/modem<br>• Entre em contato com sua operadora de internet<br>• Tente usar cabo de rede ao invés de Wi-Fi<br><br>Deseja abrir um chamado mesmo assim?",
          type: "yesno",
          field: "abrirChamadoMesmoAssim",
          next: (answer) => {
            if (answer) return "modulo";
            return "fechamento-internet";
          },
        },
        {
          id: "lentidao-solicita-teste",
          text: "⏸️ <strong>Por favor, teste sua internet primeiro!</strong><br><br>Acesse <a href='https://www.speedtest.net/' target='_blank'>Speedtest</a> e depois volte aqui.<br><br>Sua internet está com mais de 10 Mbps?",
          type: "yesno",
          field: "internetOk",
          next: (answer) => {
            if (answer) return "lentidao-navegador";
            return "lentidao-problema-internet";
          },
        },
        {
          id: "lentidao-navegador",
          text: "🌍 <strong>O problema ocorre em qual navegador?</strong>",
          type: "options",
          field: "navegador",
          options: [
            { value: "chrome", label: "🟢 Google Chrome" },
            { value: "edge", label: "🔵 Microsoft Edge" },
            { value: "firefox", label: "🟠 Mozilla Firefox" },
            { value: "safari", label: "🔵 Safari" },
            { value: "outro", label: "➕ Outro navegador" },
          ],
          next: "lentidao-testou-outro-navegador",
        },
        {
          id: "lentidao-testou-outro-navegador",
          text: "🔄 <strong>Você testou em outro navegador?</strong><br><br>Exemplo: Se está lento no Chrome, testou no Edge ou Firefox?",
          type: "yesno",
          field: "testouOutroNavegador",
          next: (answer) => {
            if (answer) return "lentidao-problema-navegador-especifico";
            return "lentidao-solicita-teste-navegador";
          },
        },
        {
          id: "lentidao-solicita-teste-navegador",
          text: "🔍 <strong>Por favor, teste em outro navegador!</strong><br><br>Se funcionar rápido em outro navegador, o problema pode ser cache ou extensões.<br><br>Funcionou bem em outro navegador?",
          type: "yesno",
          field: "funcionouOutroNavegador",
          next: (answer) => {
            if (answer) return "lentidao-problema-navegador-especifico";
            return "limpoucache";
          },
        },
        {
          id: "lentidao-problema-navegador-especifico",
          text: "💡 <strong>O problema parece ser específico do navegador!</strong><br><br>Tente:<br>• Limpar cache e cookies do navegador<br>• Desabilitar extensões temporariamente<br>• Atualizar o navegador<br><br>Já tentou limpar o cache?",
          type: "yesno",
          field: "limpouCache",
          next: (answer) => {
            if (answer) return "limpoucache-persistiu";
            return "como-limpar-cache";
          },
        },
        {
          id: "como-limpar-cache",
          text: "🧹 <strong>Como limpar o cache:</strong><br><br>Chrome/Edge: CTRL + SHIFT + DELETE<br>Firefox: CTRL + SHIFT + DELETE<br><br>Depois de limpar, o problema persistiu?",
          type: "yesno",
          field: "problemaPersiste",
          next: (answer) => {
            if (answer) return "limpoucache-persistiu";
            return "fechamento-cache-resolveu";
          },
        },
        {
          id: "fechamento-internet",
          text: "👍 <strong>Ótimo!</strong><br><br>Resolva primeiro o problema de internet e depois, se a lentidão persistir, retorne aqui para abrir um chamado.<br><br>Qualquer coisa, estamos à disposição! 😊",
          type: "final",
        },
        {
          id: "fechamento-cache-resolveu",
          text: "🎉 <strong>Que bom que resolveu!</strong><br><br>Se o problema voltar, não hesite em nos contatar novamente.<br><br>Tenha um ótimo dia! 😊",
          type: "final",
        },
        {
          id: "mensagemerro",
          text: "📋 <strong>Qual é a mensagem de erro exibida?</strong><br><small>Copie e cole a mensagem completa, se possível.</small>",
          type: "text",
          field: "errorMessage",
          next: "limpoucache",
        },
        {
          id: "limpoucache",
          text: "🧹 <strong>Você já tentou limpar o cache do navegador?</strong><br><small>Pressione Ctrl + Shift + Delete e limpe os dados de navegação.</small>",
          type: "yesno",
          field: "limpouCache",
          next: (answer) => (!answer ? "dicacache" : "modulo"),
        },
        {
          id: "dicacache",
          text: '💡 <strong>Recomendo limpar o cache primeiro!</strong><br><br>Como fazer:<br>1️⃣ Pressione <code>Ctrl + Shift + Delete</code><br>2️⃣ Selecione "Imagens e arquivos em cache"<br>3️⃣ Clique em "Limpar dados"<br>4️⃣ Recarregue a página (F5)<br><br>✅ <strong>Depois de limpar o cache, o problema continua?</strong>',
          type: "yesno",
          field: "problemaPersiste",
          next: (answer) => (answer ? "modulo" : "resolvido"),
        },
        {
          id: "resolvido",
          text: "🎉 <strong>Que ótimo! Problema resolvido!</strong><br><br>Se precisar de ajuda novamente, estou aqui. 😊",
          type: "final",
          action: "close",
        },
        {
          id: "modulo",
          text: "📍 <strong>Em qual módulo/tela está acontecendo?</strong><br><small>Ex: Dashboard, Cadastro de Clientes, Relatórios, etc.</small>",
          type: "text",
          field: "moduleAffected",
          next: "registroespecifico",
        },
        {
          id: "registroespecifico",
          text: "🔎 <strong>O problema acontece em um registro específico?</strong><br><small>Por exemplo: apenas com um cliente, produto ou pedido específico.</small>",
          type: "yesno",
          field: "registroEspecifico",
          next: "outrosusuarios",
        },
        {
          id: "outrosusuarios",
          text: "👥 <strong>Outros usuários estão com o mesmo problema?</strong><br><small>Verifique com colegas se eles conseguem reproduzir.</small>",
          type: "yesno",
          field: "outrosUsuarios",
          next: "teminformacoes",
        },
        {
          id: "teminformacoes",
          text: "📋 <strong>Você possui todas as informações?</strong><br><small>Passos para reproduzir, horário do erro, prints de tela, etc.</small>",
          type: "yesno",
          field: "temInformacoes",
          next: "diagnostico",
        },
        {
          id: "diagnostico",
          text: "🤔 Analisando as informações...",
          type: "diagnostic",
          next: null,
        },
      ],
    };
  },

  mounted() {
    // Register global handler for option buttons
    window.handleChatbotOption = (value) => {
      this.handleOptionResponse(value);
    };

    // NÃO carrega sistemas aqui - será carregado quando abrir o chat
    // para garantir que o usuário já está autenticado
  },

  beforeDestroy() {
    // Clean up global handler
    delete window.handleChatbotOption;
  },

  computed: {
    currentInputField() {
      const question = this.flowQuestions.find(
        (q) => q.id === this.currentQuestionId
      );
      return question?.field || "description";
    },
    currentInputPlaceholder() {
      const question = this.flowQuestions.find(
        (q) => q.id === this.currentQuestionId
      );
      const placeholders = {
        systemName: "Ex: Sistema de Vendas, ERP, CRM...",
        departmentName: "Ex: TI, Financeiro, RH, Comercial...",
        description: "Descreva o problema que você está enfrentando...",
        errorMessage: "Cole aqui a mensagem de erro completa...",
        moduleAffected: "Ex: Dashboard, Cadastro de Clientes, Relatórios...",
      };
      return placeholders[question?.field] || "Digite sua resposta...";
    },
  },

  methods: {
    async openChat() {
      this.isOpen = true;
      this.resetChat();

      // Carrega sistemas e departamentos quando abre o chat (usuário já está autenticado)
      await Promise.all([this.loadSystems(), this.loadDepartments()]);

      setTimeout(() => {
        this.showQuestion("inicio");
      }, 500);
    },

    closeChat() {
      this.isOpen = false;
      this.resetChat();
    },

    resetChat() {
      this.currentQuestionId = "inicio";
      this.messages = [];
      this.showInitialInput = false;
      this.waitingForResponse = false;
      this.diagnosticData = {
        systemName: "",
        departmentName: "",
        problemType: null,
        description: "",
        errorMessage: "",
        moduleAffected: "",
        limpouCache: null,
        problemaPersiste: null,
        registroEspecifico: null,
        outrosUsuarios: null,
        temInformacoes: null,
      };
    },

    addBotMessage(text, showButtons = false) {
      this.messages.push({
        type: "bot",
        text,
        showButtons,
      });
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },

    addUserMessage(text) {
      this.messages.push({
        type: "user",
        text,
      });
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },

    showQuestion(questionId) {
      const question = this.flowQuestions.find((q) => q.id === questionId);
      if (!question) {
        console.error(`Question with id "${questionId}" not found`);
        return;
      }

      this.currentQuestionId = questionId;

      if (question.type === "final") {
        this.addBotMessage(question.text);
        if (question.action === "close") {
          setTimeout(() => this.closeChat(), 3000);
        }
        return;
      }

      if (question.type === "diagnostic") {
        this.addBotMessage(question.text);
        setTimeout(() => this.runDiagnostic(), 1500);
        return;
      }

      if (question.type === "yesno") {
        this.addBotMessage(question.text, true);
        this.waitingForResponse = false;
        return;
      }

      if (question.type === "options") {
        this.addBotMessage(question.text);
        setTimeout(() => {
          this.addOptionButtons(question.options);
        }, 500);
        return;
      }

      if (question.type === "text") {
        this.addBotMessage(question.text);
        setTimeout(() => {
          // Para perguntas de texto, reutiliza o input inicial ao invés de criar inline
          this.showInitialInput = true;
        }, 500);
        return;
      }
    },

    addOptionButtons(options) {
      const buttonsHtml = options
        .map(
          (opt, index) =>
            `<button class="option-btn" data-value="${opt.value}" onclick="window.handleChatbotOption('${opt.value}')">${opt.label}</button>`
        )
        .join("");

      this.messages.push({
        type: "bot",
        text: `<div class="options-container">${buttonsHtml}</div>`,
        showButtons: false,
      });

      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },

    showTextInput(question) {
      this.messages.push({
        type: "input",
        questionId: question.id,
        field: question.field,
      });

      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },

    submitDescription() {
      // Verifica qual campo está sendo preenchido
      const currentQuestion = this.flowQuestions.find(
        (q) => q.id === this.currentQuestionId
      );

      if (
        !currentQuestion ||
        !this.diagnosticData[currentQuestion.field]?.trim()
      ) {
        return;
      }

      this.addUserMessage(this.diagnosticData[currentQuestion.field]);
      this.showInitialInput = false;

      // Continua o fluxo normalmente
      setTimeout(() => {
        this.addBotMessage("✅ Perfeito! Vamos continuar...");
        setTimeout(() => {
          this.processAnswer(
            this.currentQuestionId,
            this.diagnosticData[currentQuestion.field]
          );
        }, 800);
      }, 500);
    },

    processAnswer(questionId, answer) {
      const question = this.flowQuestions.find((q) => q.id === questionId);
      if (!question) return;

      // Save answer to diagnosticData
      if (question.field) {
        this.diagnosticData[question.field] = answer;

        // Se for sistema, salva também o ID e client_id
        if (question.field === "systemName" && questionId === "inicio") {
          const selectedOption = question.options.find(
            (opt) => opt.value === answer
          );
          if (selectedOption && selectedOption.id) {
            this.diagnosticData.systemId = selectedOption.id;
            this.diagnosticData.clientId = selectedOption.clientId;
          }
        }

        // Se for departamento, salva também o ID
        if (
          question.field === "departmentName" &&
          questionId === "departamento"
        ) {
          const selectedOption = question.options.find(
            (opt) => opt.value === answer
          );
          if (selectedOption && selectedOption.id) {
            this.diagnosticData.departmentId = selectedOption.id;
          }
        }
      }

      // Determine next question
      let nextQuestionId = null;
      if (typeof question.next === "function") {
        nextQuestionId = question.next(answer);
      } else {
        nextQuestionId = question.next;
      }

      // Show next question
      if (nextQuestionId) {
        setTimeout(() => {
          this.showQuestion(nextQuestionId);
        }, 800);
      }
    },

    handleResponse(answer) {
      this.waitingForResponse = true;

      // Add user response
      this.addUserMessage(answer ? "✅ Sim" : "❌ Não");

      // Process the answer
      this.processAnswer(this.currentQuestionId, answer);
    },

    handleTextSubmit(field) {
      const value = this.diagnosticData[field];
      if (!value || !value.trim()) return;

      // Add user message
      this.addUserMessage(value);

      // Remove the input from messages
      this.messages = this.messages.filter((m) => m.type !== "input");

      // Process the answer
      this.processAnswer(this.currentQuestionId, value);
    },

    handleOptionResponse(value) {
      const question = this.flowQuestions.find(
        (q) => q.id === this.currentQuestionId
      );
      if (!question) return;

      // Find the selected option label
      const selectedOption = question.options.find(
        (opt) => opt.value === value
      );
      if (selectedOption) {
        this.addUserMessage(selectedOption.label);
      }

      // Process the answer
      this.processAnswer(this.currentQuestionId, value);
    },
    runDiagnostic() {
      // Count how many fields are filled
      const filledFields = Object.entries(this.diagnosticData).filter(
        ([key, value]) => {
          if (key === "problemaPersiste") return false; // Don't count this
          return value !== null && value !== "" && value !== undefined;
        }
      ).length;

      const hasError = this.diagnosticData.errorMessage?.trim();
      const hasModule = this.diagnosticData.moduleAffected?.trim();
      const hasDescription = this.diagnosticData.description?.trim();

      // Smart diagnostic logic
      const shouldOpenTicket =
        filledFields >= 4 ||
        (hasError && hasModule) ||
        (hasDescription && hasModule && filledFields >= 3);

      this.addBotMessage("🤔 Analisando as informações coletadas...");

      setTimeout(() => {
        if (shouldOpenTicket) {
          this.addBotMessage(
            `✅ <strong>Ótimo trabalho!</strong><br><br>` +
              `Você forneceu ${filledFields} informações importantes que vão ajudar muito na resolução.<br><br>` +
              "🎫 Vou te redirecionar para abrir o chamado com tudo já preenchido!"
          );

          setTimeout(() => {
            this.redirectToNewCall();
          }, 2000);
        } else {
          this.addBotMessage(
            "⚠️ <strong>Recomendo reunir mais informações antes de abrir o chamado:</strong><br><br>" +
              (!hasDescription ? "• Descreva melhor o problema<br>" : "") +
              (!hasModule
                ? "• Identifique em qual tela/módulo ocorre<br>"
                : "") +
              (!this.diagnosticData.limpouCache
                ? "• Limpe o cache do navegador (Ctrl + Shift + Delete)<br>"
                : "") +
              (!hasError && this.diagnosticData.problemType === "erro"
                ? "• Copie a mensagem de erro exata<br>"
                : "") +
              (!this.diagnosticData.temInformacoes
                ? "• Reúna prints, horário e passos para reproduzir<br>"
                : "") +
              "<br>💡 <strong>Quanto mais informações, mais rápido resolveremos!</strong><br><br>" +
              "Você ainda pode abrir o chamado mesmo assim:"
          );

          setTimeout(() => {
            this.addBotMessage(
              '<div class="diagnostic-actions">' +
                '<button class="btn-proceed" onclick="window.proceedToTicket()">📋 Abrir chamado mesmo assim</button>' +
                '<button class="btn-restart" onclick="location.reload()">🔄 Reiniciar conversa</button>' +
                "</div>"
            );

            window.proceedToTicket = () => {
              this.redirectToNewCall();
            };
          }, 1500);
        }
      }, 1500);
    },

    redirectToNewCall() {
      // Prepare data for the form
      const callData = {
        description: this.diagnosticData.description,
        triagem: this.diagnosticData,
      };

      // Store in localStorage to be retrieved on the creation page
      localStorage.setItem("chatbot_triagem", JSON.stringify(callData));

      // Redirect to new call page
      this.$router.push({
        name: "NewCall",
        query: { from_chatbot: true },
      });

      this.closeChat();
    },

    scrollToBottom() {
      const container = this.$refs.messagesContainer;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },

    // Buscar sistemas da API
    async loadSystems() {
      try {
        const user = this.$store.state.user;
        const perfil_id =
          user.perfil_id || parseInt(localStorage.getItem("perfil_id"));


        let response;

        // Se o usuário é cliente (access_nivel == 10) e tem client_id, busca apenas seus projetos
        if (perfil_id === 10 && user.client_id) {
          response = await axios.get(
            this.$store.state.api + `clients/${user.client_id}/projects`
          );
          this.systems = response.data.projects || [];
        } else {
          // Se é desenvolvedor/admin, busca todos os sistemas públicos
          response = await axios.get(this.$store.state.api + "projects-public");
          this.systems = response.data.data || [];
        }

        // Atualiza as opções do flowQuestions dinamicamente
        const sistemaPergunta = this.flowQuestions.find(
          (q) => q.id === "inicio"
        );
        if (sistemaPergunta) {
          sistemaPergunta.options = [
            ...this.systems.map((sys) => ({
              value: sys.name,
              label: `🖥️ ${sys.name}`,
              id: sys.id,
              clientId: sys.client_id || user.client_id,
            })),
            { value: "outro", label: "✏️ Outro sistema (digitar)" },
          ];
        }
      } catch (error) {
        console.error("Erro ao carregar sistemas:", error);
      }
    },

    // Buscar departamentos da API
    async loadDepartments() {
      try {
        const response = await axios.get(this.$store.state.api + "departments");
        this.departments = response.data.data || [];

        // Atualiza as opções do flowQuestions dinamicamente
        const deptPergunta = this.flowQuestions.find(
          (q) => q.id === "departamento"
        );
        if (deptPergunta) {
          deptPergunta.options = [
            ...this.departments.map((dept) => ({
              value: dept.name,
              label: `🏢 ${dept.name}`,
              id: dept.id,
            })),
            { value: "outro", label: "✏️ Outro (digitar)" },
          ];
        }
      } catch (error) {
        console.error("Erro ao carregar departamentos:", error);
      }
    },
  },
};
</script>

<style scoped>
/* Botão Flutuante */
.chatbot-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(115, 103, 240, 0.4);
  transition: all 0.3s ease;
  z-index: 1000;
  animation: pulse 2s infinite, fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.chatbot-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 30px rgba(115, 103, 240, 0.6);
}

.chatbot-button svg {
  color: white;
}

.pulse-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid #7367f0;
  opacity: 0;
  animation: pulseRing 2s infinite;
}

@keyframes pulseRing {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.3;
  }
  100% {
    transform: scale(1.4);
    opacity: 0;
  }
}

@keyframes pulse {
  0%,
  100% {
    box-shadow: 0 4px 20px rgba(115, 103, 240, 0.4);
  }
  50% {
    box-shadow: 0 4px 30px rgba(115, 103, 240, 0.7);
  }
}

/* Container do Chat */
.chatbot-container {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 400px;
  max-width: calc(100vw - 40px);
  height: 600px;
  max-height: calc(100vh - 100px);
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  z-index: 1001;
  overflow: hidden;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Header */
.chatbot-header {
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  color: white;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
}

.close-btn {
  cursor: pointer;
  transition: transform 0.2s;
}

.close-btn:hover {
  transform: rotate(90deg);
}

/* Messages Area */
.chatbot-messages {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.message {
  display: flex;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message.bot {
  justify-content: flex-start;
}

.message.user {
  justify-content: flex-end;
}

.message-content {
  max-width: 80%;
  padding: 12px 16px;
  border-radius: 12px;
  word-wrap: break-word;
}

.message.bot .message-content {
  background: white;
  color: #333;
  border-bottom-left-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.message.user .message-content {
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  color: white;
  border-bottom-right-radius: 4px;
}

.message-content p {
  margin: 0;
  line-height: 1.5;
}

/* Botões de Resposta */
.response-buttons {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.response-buttons button {
  flex: 1;
  padding: 10px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-yes {
  background: #28c76f;
  color: white;
}

.btn-yes:hover:not(:disabled) {
  background: #24b364;
  transform: translateY(-2px);
}

.btn-no {
  background: #ea5455;
  color: white;
}

.btn-no:hover:not(:disabled) {
  background: #d63031;
  transform: translateY(-2px);
}

.response-buttons button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Options Container */
.options-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.option-btn {
  padding: 12px;
  background: #f8f8f8;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  font-size: 14px;
}

.option-btn:hover {
  background: #7367f0;
  color: white;
  border-color: #7367f0;
  transform: translateX(4px);
}

/* Inline Input Container */
.input-container-inline {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  background: white;
  border-radius: 8px;
  margin-top: 8px;
  width: 100%;
}

.input-container-inline textarea {
  flex: 1;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  resize: none;
  font-family: inherit;
  font-size: 13px;
}

.input-container-inline textarea:focus {
  outline: none;
  border-color: #7367f0;
}

.btn-send-inline {
  padding: 8px 12px;
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-send-inline:hover:not(:disabled) {
  transform: scale(1.05);
}

.btn-send-inline:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Diagnostic Actions */
.diagnostic-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
}

.btn-proceed,
.btn-restart {
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-proceed {
  background: #7367f0;
  color: white;
}

.btn-proceed:hover {
  background: #5e51e6;
  transform: translateY(-2px);
}

.btn-restart {
  background: #f0f0f0;
  color: #333;
}

.btn-restart:hover {
  background: #e0e0e0;
}

/* Input Container */
.input-container {
  background: white;
  padding: 12px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-container textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  resize: none;
  font-family: inherit;
  font-size: 14px;
  transition: border-color 0.2s;
}

.input-container textarea:focus {
  outline: none;
  border-color: #7367f0;
}

.btn-send {
  align-self: flex-end;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-send:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(115, 103, 240, 0.4);
}

.btn-send:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Scrollbar */
.chatbot-messages::-webkit-scrollbar {
  width: 6px;
}

.chatbot-messages::-webkit-scrollbar-track {
  background: transparent;
}

.chatbot-messages::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

.chatbot-messages::-webkit-scrollbar-thumb:hover {
  background: #999;
}

/* Mobile */
@media (max-width: 768px) {
  .chatbot-container {
    width: calc(100vw - 20px);
    height: calc(100vh - 80px);
    bottom: 10px;
    right: 10px;
  }

  .chatbot-button {
    bottom: 20px;
    right: 20px;
  }
}
</style>
